import { HttpAuth } from '../../config/Http'
import { changeAlert } from './alert.action';
import { changeLoading } from './loading.action';
import { changeNotify } from './notify.action';

export const actionTypes = {
    INDEX: 'USUARIOS_INDEX',
    RIFAS: 'USUARIOS_RIFAS',
    BILHETES: 'USUARIOS_BILHETES',
    UPDATE: 'BILHETES_UPDATE'
};

export const indexResponse = (payload, isLoadMore) => ({
    type: actionTypes.INDEX,
    payload,
    isLoadMore
})

export const index = (query, isLoadMore = null) => dispatch => {
    return HttpAuth.get('/users?'+ new URLSearchParams(query))
        .then(res => res && dispatch(indexResponse(res.data, isLoadMore)))
        .catch(error => {
            dispatch( changeLoading({ open: false }) );
    
            if(typeof error.response !== 'undefined') {
                if(error.response.status === 400) {
                    if(typeof error.response.data === 'object'){
                        
                        if(typeof error.response.data.error !== undefined) {
                            if(typeof error.response.data.error === 'string'){
                                dispatch( changeNotify({
                                    open: true,
                                    class: 'error',
                                    msg: error.response.data.error
                                }))
                            }
                        }
                    }
                }
            }
        })
}

// SHOW

export const show = (id) => dispatch => {
    return HttpAuth.get('/users/'+ id)
        .then(res => typeof res !== 'undefined' && dispatch(indexResponse(res.data)))
        .catch(error => {
            dispatch( changeLoading({ open: false }) );
    
            if(typeof error.response !== 'undefined') {
                if(error.response.status === 400) {
                    if(typeof error.response.data === 'object'){
                        if(typeof error.response.data.error !== undefined) {
                            if(typeof error.response.data.error === 'string'){
                                dispatch( changeNotify({
                                    open: true,
                                    class: 'error',
                                    msg: error.response.data.error
                                }))
                            }
                        }

                        if(typeof error.response.data.class !== undefined) {
                            dispatch(changeNotify({
                                open: true,
                                msg: error.response.data.msg,
                                class: error.response.data.class
                            }))
                        }
                    }
                }
            }
        })
}

// REPORTS

export const reports = (filter) => dispatch => {
    dispatch(changeLoading({ 
        open: true,
        msg: 'Gerando relatório...'
    }))
    return HttpAuth.post('/usuarios/reports', filter)
        .then((res) => {
            if (res.status !== 200) throw new Error('Erro na resposta');

            dispatch(changeLoading({ 
                open: false,
                msg: 'Carregando...'
            }))

            if(res.status === 200) {
                const form = document.createElement('form');
                const secureUrl = res.data.url.replace('http:', 'https:');
                const urlObj = new URL(secureUrl)
                form.action = urlObj.origin + urlObj.pathname;
                form.method = 'GET';

                form.style.display = 'none';

                urlObj.searchParams.forEach((value, key) => {
                    const input = document.createElement('input');
                    input.type = 'hidden';
                    input.name = key;
                    input.value = value;
                    form.appendChild(input);
                });
                
                document.body.appendChild(form);
                form.submit();
            }
        })
        .catch((error) => {
            dispatch(changeLoading({ 
                open: false,
                msg: 'Carregando...'
            }))
            
            dispatch(changeNotify({
                open: true,
                msg: 'Erro ao baixar o relatório.',
                class: 'error'
            }))
        });
}

// BLOCK

export const blockUser = (id, status) => dispatch => {
    dispatch(changeLoading({ 
        open: true
    }))

    return HttpAuth.post('/users/'+id+'/'+ status)
    .then(res => {
        dispatch(changeLoading({ open: false }))
        
        if(typeof res !== 'undefined') {
            if(res.data.success === 200) {
                dispatch(changeNotify({
                    open: true,
                    msg: res.data.msg,
                    class: 'success'
                }))
            }
        }
    })
    .catch(erro => {
        if(erro.response) {
            if(erro.response.data.msg) {
                dispatch(changeAlert({
                    open: true,
                    msg: erro.response.data.msg,
                    class: 'error'
                }))
            }
        }
        dispatch(changeLoading({ open: false }))
    })
}